import { GenericCartItem } from '@contexts/GenericCartContext/genericCart.types';
import { useGenericCart } from '@contexts/GenericCartContext/GenericCartContext';
import { Icon, Button, Typography } from '@design-system';
import { FaShoppingBasket } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

import './CartRecap.scss';

export type CartRecapProps = {
    items: GenericCartItem[];
    type?: 'appro' | 'epi';
};

export const CartRecap = ({ items, type = 'appro' }: CartRecapProps) => {
    const navigate = useNavigate();

    const { savedOrderId } = useGenericCart({ type });

    if (items.length === 0) {
        return <></>;
    }

    const totalQuantity = items.reduce((acc, item) => acc + item.quantity, 0);

    const getCartPath = () => {
        if (type === 'epi') {
            return savedOrderId ? `/sante-securite/epi/cart/${savedOrderId}` : '/sante-securite/epi/cart';
        } else {
            return savedOrderId ? `/mes-chantiers/approvisionnement/cart/${savedOrderId}` : '/mes-chantiers/approvisionnement/cart';
        }
    };

    return (
        <div className="cart-recap">
            <div className="cart-recap-icon">
                <Icon variant="surrounded" color="green" size={14} icon={<FaShoppingBasket />} />
            </div>

            <Typography intrinsic="p" variant="secondary" className="cart-recap-text">
                {totalQuantity === 1 ? `${totalQuantity} article` : `${totalQuantity} articles`}
            </Typography>

            <Button
                color="marine"
                size="fullwidth"
                onClick={() => {
                    navigate(getCartPath());
                }}
            >
                <Typography intrinsic="h4" variant="secondary">
                    Valider le panier
                </Typography>
            </Button>
        </div>
    );
};
